import { selectGalleryItem, selectReadonlyGalleryItem } from '@tabeeb/modules/gallery/actions'
import { onDisableSelection } from '@tabeeb/modules/playerToolbar/actions/drawing'
import { combineActions, handleActions } from 'redux-actions'

import * as annotationsActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [annotationsActions.setSelectedAnnotationsIds](state, action) {
      const annotationIds = action.payload

      return annotationIds
    },
    [annotationsActions.addAnnotationToSelection](state, action) {
      const annotationId = action.payload

      return [...state, annotationId]
    },
    [annotationsActions.removeAnnotationFromSelection](state, action) {
      const annotationId = action.payload

      return state.filter((id) => id !== annotationId)
    },
    [combineActions(
      selectGalleryItem,
      selectReadonlyGalleryItem,
      onDisableSelection,
      annotationsActions.resetAnnotationsState,
      annotationsActions.resetSelectedAnnotationsIds
    )](state, action) {
      return defaultState
    },
  },
  defaultState
)
